import React, { Component } from 'react'
import Lottie from 'react-lottie';
import * as animationData from './load.json'

export default class Load extends Component {

    constructor(props) {
        super(props);
        this.state = { isStopped: false, isPaused: false };
    }

    render() {
        const { screenWidth, screenHeight } = this.state;

        const defaultOptions = {
            loop: true,
            autoplay: true,
            animationData: animationData.default,
            rendererSettings: {
                preserveAspectRatio: 'xMidYMid slice'
            }
        };

        const styles = {
            svg: {
                width: "100%",
                heigth: "100px"
            },
            grid: {
                width: "100px"
            }
        }

        return (
            (this.props.active) ?
                <div className="d-flex justify-content-center align-items-center text-white" style={{ position: "fixed", width: screenWidth, height: screenHeight, background: "rgba(0,0,0,.7)", top: 0, left: 0, right: 0, bottom: 0 }}>
                    <div style={styles.grid}>
                        <Lottie
                            options={defaultOptions}
                            style={styles.svg}
                            isStopped={false}
                            isPaused={false} />
                    </div>
                </div>
                : <></>
        );

    }
}